<template>
  <div id="adminContainer">
    <div class="inner">
      <div
        style="
          width: 6px;
          height: 20px;
          background: #464775;
          float: left;
          margin-right: 10px;
        "
      ></div>
      <div style="float: left; position: relative; top: -4px">
        <h3 class="pr-3" style="font-weight: 600">이력관리</h3>
      </div>
      <div
        style="
          clear: both;
          width: 99%;
          height: 2.5px;
          background-color: #e9e9e9;
        "
      ></div>
      <!--tabContent-->
      <div class="tabContent">
        <!-- 사용자 이력관리  -->
        <div id="tabs-3" class="tabPage" v-show="userActionLogTab">
          <div class="tab_Top">
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 15px;
                margin-left: 10px;
              "
            >
              <input
                class="search-inputbox"
                style="width: 150px"
                type="text"
                placeholder="사용자로 검색"
                v-model="filter.searchTxt"
                @keyup.enter="searchActionLog(true)"
              />
              <div class="date" style="display: flex; align-items: center">
                <date-picker
                  v-model="filter.startDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :lang="lang"
                  style="width: 125px; height: 30px; font-size: 13px"
                ></date-picker>

                <span
                  class="hyphen"
                  style="margin: 0 5px; padding-top: 0; color: #333"
                  >~</span
                >
                <date-picker
                  v-model="filter.endDate"
                  format="YYYY-MM-DD"
                  value-type="format"
                  :lang="lang"
                  style="width: 125px; height: 30px; font-size: 13px"
                  :disabled-date="notBeforeStartDate"
                ></date-picker>
              </div>
              <button class="btnPrimary" @click="searchActionLog(true)">
                검색
              </button>
            </div>
          </div>

          <div class="tbw_tb01">
            <table>
              <caption>
                회의참여 이력관리
              </caption>
              <thead>
                <tr>
                  <th>변경일시</th>
                  <!-- <th>이메일</th> -->
                  <th>사용자</th>
                  <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(listItem, index) in filterLimitUserActionLog"
                  :key="index"
                >
                  <td>
                    <span class="org">{{
                      listItem.created | logTimeFilter
                    }}</span>
                  </td>
                  <!-- <td>{{ listItem.actionEmail }}</td> -->
                  <td>{{ listItem.actionUsr }}</td>
                  <td class="org">{{ listItem.action }}</td>
                  <!-- <td><span class="org">{{ listItem.info }}</span></td> -->
                </tr>
              </tbody>
            </table>

            <div class="total_num">
              <p class="fl" style="padding-top: 5px">
                <span>Rows per page :</span
                ><span style="padding-right: 10px">{{ perPage }}</span
                ><span>Total</span><span>{{ userActionLogList.length }}</span>
              </p>
            </div>
          </div>

          <div class="paging">
            <div class="boardnavi">
              <pagination
                :records="userActionLogList.length"
                v-model="page"
                :per-page="perPage"
              />
            </div>
          </div>
        </div>
      </div>
      <!--//tabContent-->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import Pagination from 'vue-pagination-2';
import VueEnglishdatepicker from 'vue-englishdatepicker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Util from '@/util';

export default {
  filters: {
    conferenceDayFilter: function (day) {
      return moment(day).format('YYYY.MM.DD');
    },
    conferenceTimeFilter: function (time) {
      return moment(time).format('HH:mm');
    },
    logTimeFilter: function (dTime) {
      return moment(dTime).format('YYYY-MM-DD / HH:mm:ss');
    },
  },
  components: {
    Pagination,
    DatePicker,
    VueEnglishdatepicker,
  },
  data: () => ({
    page: 1,
    perPage: 10,
    userLogPage: 1,
    meetingUsageTab: false,
    roleChangeLogTab: false,
    userActionLogTab: false,
    statisticsList: [
      // { id: 'meetingUsageTab', title: '회의참여 이력관리', isActive: false },
      // { id: 'roleChangeLogTab', title: '사용승인 이력관리', isActive: false },
      { id: 'userActionLogTab', title: '사용자 이력관리', isActive: false },
    ],
    lang: {
      days: ['일', '월', '화', '수', '목', '금', '토'],
      months: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ],
      yearFormat: 'YYYY년',
      monthFormat: 'MM월',
      // the calendar title of month before year
      monthBeforeYear: false,
    },
    roleChangeLogList: [],
    userActionLogList: [],
    filter: {
      searchTxt: null,
      startDate: null,
      endDate: null,
    },
    isActive: 'none',
    isEndActive: 'none',
  }),
  computed: {
    filterLimitRoleChangeLog() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.roleChangeLogList.slice(startPage, limitPage);
    },
    filterLimitUserActionLog() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.userActionLogList.slice(startPage, limitPage);
    },
  },
  async activated() {
    if (!Util.hasSession(this)) return;
    if (this.$store.state.user.authorize !== 'a') {
      this.$router.push('/');
    }
    this.initData();
  },
  methods: {
    currentTab: function (obj) {
      let id = obj.id;
      this.isActive = 'none';
      this.isEndActive = 'none';

      this.statisticsList.forEach((element) => {
        element.isActive = false;
      });
      obj.isActive = true;
      this.clearTabs();
      switch (id) {
        // case 'meetingUsageTab':  /* 회의사용조회 */
        //   this.meetingUsageTab = true;
        //   break;
        case 'roleChangeLogTab' /* 권한 변경 이력관리 */:
          this.searchRoleLog();
          this.roleChangeLogTab = true;
          break;
        case 'userActionLogTab' /* 사용자 접속 이력관리 */:
          this.searchActionLog(true);
          this.userActionLogTab = true;
          break;
      }
    },
    clearTabs: function () {
      // this.meetingUsageTab = false;
      this.roleChangeLogTab = false;
      this.userActionLogTab = false;
    },
    initData() {
      this.filter.startDate = moment().format('YYYY-MM-DD');
      this.filter.endDate = moment().format('YYYY-MM-DD');

      this.currentTab(this.statisticsList[0]);
    },
    allowedStartDates(d) {
      return (
        moment(d).format('YYYY-MM-DD') <=
        moment(this.filter.endDate).format('YYYY-MM-DD')
      );
    },
    allowedEndDates(d) {
      return moment(d).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD');
    },
    showDatePicker() {
      if (this.isActive === 'none') {
        this.isActive = '';
        this.isEndActive = 'none';
      } else {
        this.isActive = 'none';
      }
    },
    startDateChange() {
      this.isActive = 'none';
      // this.startDate(this.startDate);
    },
    showEndDatePicker() {
      if (this.isEndActive === 'none') {
        this.isEndActive = '';
        this.isActive = 'none';
      } else {
        this.isEndActive = 'none';
      }
    },
    endDateChange() {
      this.isEndActive = 'none';
      // this.startDate(this.startDate);
    },
    searchRoleLog() {
      let params = {
        searchTxt: this.filter.searchTxt,
        startDate: `${moment(
          moment(this.filter.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(
          moment(this.filter.endDate).format('YYYY-MM-DDT23:59:59')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
        isRoleChangeLog: true,
      };
      this.$http
        .get(`/api/v1/logs`, { params: params })
        .then((response) => {
          this.roleChangeLogList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    searchActionLog(isInit) {
      if (isInit) {
        this.page = 1;
      }
      let params = {
        searchTxt: this.filter.searchTxt,
        startDate: `${moment(
          moment(this.filter.startDate).format('YYYY-MM-DDT00:00:00')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        endDate: `${moment(
          moment(this.filter.endDate).format('YYYY-MM-DDT23:59:59')
        )
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss')}Z`,
        siteName: this.$store.state.user.siteName,
        isRoleChangeLog: false,
      };
      this.$http
        .get(`/api/v1/logs`, { params: params })
        .then((response) => {
          this.userActionLogList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    notBeforeStartDate(date) {
      return date < new Date(this.filter.startDate);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/sections/ManageHistory.vue